<template>

  <!--3- to hide on iOS -->
  <!-- <div v-if="!isIos()"> -->
    <div class="ms-2 me-2 text-center mt-10">

        <div v-if="!this.isLoading" class="sticky top-0  w-full flex flex-col items-center ">

            <div v-if="user.length > 0 " class="p-4 :p-8 w-full">
                    
                <verify-code class="w-full self-center rounded lg:rounded-full bg-blue-400" :user="user[0]" :callReload="callReload"></verify-code>
            </div>
        </div>

        <div class="flex flex-col items-center p-3 lg:p-10 rounded-lg bg-purple-100 border-blue-800 border-4">
            <p class="mt-2 lg:mt-10 p-5">{{$t('profile.loggedInWith')}}:</p>
            <p class="mt-2 lg:mt-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">{{$t('profile.email')}}<strong>  {{ email }} </strong></p>
        </div>
    
        <div v-if="this.isLoading" class="w-full flex justify-center">

            <ring-loader ></ring-loader> 
        </div>

        <div v-else>

            <div v-if="user.length < 1" class="flex flex-col mt-20 ">

              <!-- <div v-if="true" class="flex flex-col mt-20 "> -->

                <div  class="ms-2 me-2 mb-10 items-center rounded-lg bg-pink-200 p-10">

                    <label><strong>{{$t('profile.completeProfile')}}</strong></label>
                </div>

                <div class=" pl-2 pr-2 lg:pl-10 lg:pr-10 mb-40">
                
                    <profile-create :tokenId="tokenId" :email="email" :callReload="callReload"/>
                </div>
            </div>

            <div v-else-if="user.length > 0" class="flex flex-col items-center mt-5 lg:mt-10"> 

                <div class="w-full mb-40">

                    <div class="w-full flex justify-center">
                                
                        <button class=" mt-5 mb-5 text-center rounded-lg p-5 bg-red-400" @click="enableEditMode">{{editButtonText}}</button>
                    </div>
                
                    <profile-view v-if="user.length > 0 && editMode == false" :userInfo="user[0]"/>
                    <profile-update v-else :userInfo="user[0]" :tokenId="tokenId" :email="email" :callReload="callReload"/>

                </div>
            </div>
            </div>
        </div>
</template>

<script>


import myQueries from '../hasura/myQueries';

import profileCreate from '../components-v2/profile/ProfileCreate';

import profileView from '../components-v2/profile/ProfileView';

import profileUpdate from '../components-v2/profile/ProfileUpdate';

// import PaymentLayout from '../components/PaymentLayout';

import AppLaunch from '../views/AppLaunch';

import VerifyCode from '../components/VerifyCode';

import componentsHelpers from '../classes/componentHelpers';

import { RingLoader } from 'vue-spinners-css';


export default {
  
  async mounted(){
      console.log(`in profile v2`);

    const parameters = this.$route.query;

     if(localStorage.hasOwnProperty('businessView')){

        const businessView = localStorage.getItem('businessView');

        if(businessView == 'true'){

          const goTo = localStorage.setItem('businessLayout1', 'profile');
        }else{

          const goTo = localStorage.setItem('clientLayout1', 'profile');
        }
      }else{
        
        localStorage.setItem('clientLayout1', 'profile');
      }

      if(localStorage.hasOwnProperty("businessView")){

        if(!localStorage.getItem('businessView').includes('undefined')){

          let value = localStorage.getItem('businessView');

          // console.log(`typeof businessView ${typeof value}`);
          if (value === null) {
              // console.log('was null setting to false');
              value = false;
          } else {
              value = JSON.parse(value)
          }

          value = JSON.parse(value)

          this.isBusinessView = value;

          this.switchMenu = value;
        }
      }

    // localStorage.setItem('clientLayout1', 'profile');

    this.$layoutType = 0;

    // console.log(`parameters: ${JSON.stringify(parameters)}`);

        if(typeof parameters.success === 'undefined'){
        }
        else{

           if (parameters.success == 'true')
           {

            componentsHelpers.toastIt(this.$toasted, this.$t('profile.paymentSuccessful'), 2, 'outline', true);

           }else{

            componentsHelpers.toastIt(this.$toasted, this.$t('profile.PaymentFailed'), 3, 'outline', true);
           }
        }

     try{

          this.isLoading = true;

          await this.loadUserInfo();

          this.isLoading = false;
         }catch(e){

              this.isLoading = false;

            componentsHelpers.sendError(this.$apollo, 0,'Profile', 'main', 'mounted', e);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
         }

    if(this.editMode == true)
    { 
      this.editButtonText = this.$t("profile.cancel");

    }
    else{

      this.editButtonText = this.$t("profile.editProfile");
    }
  },

  components: {

    profileCreate,
    profileView,
    profileUpdate,
    // PaymentLayout,
    VerifyCode,
    RingLoader,
    AppLaunch
  },

  methods:{

    isIos(){

      // console.log(`isiOS: ${navigator.userAgent == 'Safari/602.1 ios-pnadi'}`);

      // return false;
      // return true;
      return navigator.userAgent == 'Safari/602.1 ios-pnadi';
    },

    callReload(){

      // console.log(`response is: ${JSON.stringify(msg)}`);
      
      // console.log(`in call reload`);
      location.reload();
    },

    enableEditMode(){

      this.editMode = !this.editMode;

      if(this.editMode == true)
      { 
        this.editButtonText = this.$t("profile.cancel");
      }
      else{

        this.editButtonText = this.$t("profile.editProfile");
      }
    },

    async loadUserInfo(){

        // console.log(`inside loadUSerInfo step 1`);
      try{


        let tokenResult = await this.$apollo.query({
          query: myQueries.token_query,
          error(error){
            
            componentsHelpers.sendError(this.$apollo, 0,'Profile', 'main', 'loadUserInfo - tokenResult', error);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

            this.tokenError = JSON.stringify(error);
          },   
      });

            // console.log(`tokenResult.data: ${JSON.stringify(tokenResult.data)}`)

      this.tokenId = tokenResult.data.token[0].id;


       this.email = tokenResult.data.token[0].email;

      // console.log(`inside loadUSerInfo after step one token is ${JSON.stringify(tokenResult)}`);


      if(this.user)
      {

          if(this.user.length > 0){

              // console.log(`********* @HOME: inside if user.length > 0 with ${JSON.stringify(this.user[0])} *************************`);
          }                
          else{

            await this.getUser();
          }
        }
        else{
          await this.getUser();
        }
      }
      catch(error){

          this.showLoader = false;

            componentsHelpers.sendError(this.$apollo, 0,'Profile', 'main', 'loadUserInfo - Catch(error)', error);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

          this.mutationError = error;
          // console.log(`Fayez Error is ${JSON.stringify(error.message)}`);
        }
    },

    async getUser(){
      
      const componentsHelpers = componentsHelpers;

      const apollo = this.$apollo;

      const toasted = this.$toasted;

      let userId = this.userId;

      const t = this.$t;

      let userResult;

      // console.log(`********* @HOME: inside else user.length > 0 *************************`);

      userResult = await this.$apollo.query({

          query: myQueries.user_query,

          variables: {
              
            userEmail: this.email
          },

          error(error){
              
              componentsHelpers.sendError(apollo, 0,'Profile', 'main', 'getUser', error);

              componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

              this.userInfoError = JSON.stringify(error);
          }
      });

      // console.log(`From Profile, userResult is ${JSON.stringify(userResult)}`);

      this.user = userResult.data.user;
      
      if(this.user.length > 0 ){

        this.userId = this.user[0].id;
        userId = this.userId;
      }

      // console.log(`user length is ${this.user.length}`);
    }
  },

    apollo: {

        // user: {
        //     query: myQueries.user_query,
             
        //     variables: {
              
        //       userEmail: this.email
        //     },

        //     error(error){
                
        //         this.userInfoError = JSON.stringify(error);
        //     }
        // },
      },

    data:()=>{
      
      return {

        tokenId: '',
        email: '',
        user:[],
        isRegistered: false,
        tokenError: '',
        userInfoError: '',
        editMode: false,
        editButtonText: '',
        amount: 10,
        isLoading: false,
        mutationError: '',
        
        //5- hide payments
        showPayments: true,
        // showPayments: false,


        userId: 0,
        isBusinessView: false
      }
    },
    
    watch:{

      amount: function (val, oldVal){

        if(val < 10){

          //alert(`Minimum amount is 10 points`);
          

          //return 10;
        }
        else{

          //return val;
        }
      }
    }
}
</script>